import { createSlice } from '@reduxjs/toolkit'
import {getActionResolutions } from "./thunks"
import { logOut } from '../authentication/authenticationSlice';

const initialState= { 
  actionResolutions: {
  }, 
  loading: "idle",
  error: null }

const actionResolutionsSlice = createSlice({
  name: 'actionResolutions',
  initialState,
  extraReducers: {
    [getActionResolutions.pending]: (state) => {
        state.loading = "loading"; 
        state.error = null
      },
    [getActionResolutions.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.actionResolutions = action.payload
      
    },
    [getActionResolutions.rejected]: (state, action) => {
        state.loading = "failed"; 
        state.error = action.error.message
      },
    [logOut]: ()=> initialState
  }
})

export default actionResolutionsSlice.reducer
